import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { from, Observable, switchMap, throwError } from 'rxjs';
import { environment } from '../environments/environment';
import { UserService } from './user.service';
import { ReplayProtectionService } from './replay-protection.service';
import { LoginCryptoService } from './login-crypto.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private apiUrl = environment.apiUrl;

  private token: string;
  constructor(private http: HttpClient, private userService: UserService, private replayProtection: ReplayProtectionService, private loginCrypto: LoginCryptoService) {
    this.token = this.userService.getAccessToken();
  }

  // Anonymous: must not send Authorization. Fetched on every login, never cached.
  getLoginPublicKey(): Observable<HttpResponse<any>> {
    return from(this.replayProtection.getReadHeaders('GetLoginPublicKey', '0')).pipe(
      switchMap(replayHeaders =>
        this.http.get(`${this.apiUrl}/api/Auth/GetLoginPublicKey`, { headers: new HttpHeaders({ ...replayHeaders }), observe: 'response' }))
    );
  }

  // VAPT "Clear Text Credentials": credentials leave the browser only as an encrypted envelope.
  // Deliberately no plaintext fallback - if encryption is unavailable the login fails.
  validateUser(username: string, password: string): Observable<HttpResponse<any>> {
    if (!this.loginCrypto.isSupported()) {
      return throwError(() => new HttpErrorResponse({ status: 0, statusText: 'CryptoUnavailable' }));
    }
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${this.token}` });
    const url = `${this.apiUrl}/api/Auth/ValidateUser`;
    return this.getLoginPublicKey().pipe(
      switchMap(res => from(this.loginCrypto.encryptLogin(res.body.publicKey, username, password))),
      switchMap(encryptedPayload =>
        this.http.post(url, { encryptedPayload }, { headers: headers, observe: 'response' }))
    );
  }

  ValidateUserRedirection(Token: string, LoginType: number): Observable<HttpResponse<any>> {
    const body = { token: Token, loginType: LoginType };
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${this.token}` });
    const url = `${this.apiUrl}/api/Auth/validateUserRedirection`;
    return this.http.post(url, body, { headers: headers, observe: 'response' });
  }

  LogoutJTIUpdate(token: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    const url = `${this.apiUrl}/api/Auth/LogoutJTIUpdate`;
    return this.http.post(url, { jwttoken: token }, { headers: headers, observe: 'response' });
  }

  ChangePassword(userId: number, password: string, oldPassword: string): Observable<HttpResponse<any>> {
    const body = { userId, password, oldPassword };
    const url = `${this.apiUrl}/api/User/ChangePassword`;
    return from(
      this.replayProtection.getHeaders(body, 'ChangePassword', String(this.userService.getUserId()))
    ).pipe(
      switchMap(replayHeaders => {
        const headers = new HttpHeaders({ 'Authorization': `Bearer ${this.userService.getAccessToken()}`, ...replayHeaders });
        return this.http.post(url, body, { headers, observe: 'response' });
      })
    );
  }
}
